import Vue from 'vue'
import App from './App.vue'
import Navbar from './Navbar.vue'
import 'jquery'
import '@fortawesome/fontawesome-free'
import VueCurrencyInput from 'vue-currency-input'
import VCalendar from 'v-calendar';
import VueTelInput from 'vue-tel-input'
import VueRouter from 'vue-router'
import Routes from "./routes";
import 'vue-tel-input/dist/vue-tel-input.css'
const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: 'EUR' }
}
Vue.use(VueCurrencyInput, pluginOptions );
Vue.use(VCalendar, {
  componentPrefix: 'v',  // Use <vc-calendar /> instead of <v-calendar />
               // ...other defaults
});
Vue.use(VueTelInput);
Vue.use(VueRouter);


const cssThemes_Default = () => import('@/css/index.css')
const cssThemes_Addons = () => import('@/css/onboardingaddons.css')
const cssThemes_DevTheme = () => import('@/css/dev.css')


window.$ = window.jQuery = require('jquery');

switch (window.$("#onboardingapp").attr("data-source")) {
  // Used in Dev-Stuff...
  case 'localhost-dev': {
    cssThemes_Default();
    cssThemes_Addons();
    cssThemes_DevTheme();
    break
  }
  default: {
    cssThemes_Default();
    cssThemes_Addons();
   break
  }
  
}


const router = new VueRouter({
  // mode:'history',
  routes: Routes
});



new Vue({
  el: "#onboardingapp",

  render: h =>
    h(App, {
      props: {
        source: ""+ window.$("#onboardingapp").attr("data-source"),
        counterpart: "" + window.$("#onboardingapp").attr("data-counterpart")
      },
      
    }), router:router,
    
});

new Vue({
  el: '#navbar',
  
	render: h =>
    h(Navbar, {
      
    }),
});



